import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _objectSpread2 from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { PureComponent } from 'react';
import classnames from 'classnames';
import Icons from '../icons';
import Card from '../Card';
import { defaultProps } from '../utils/defaultProps';
import { modalClass } from './styles';
import { Provider } from '../Scroll/context';
import { Provider as ZProvider } from './context';

var DefaultValue = _objectSpread2(_objectSpread2({}, defaultProps), {}, {
  top: '10vh',
  maskCloseAble: true,
  width: 500,
  events: {},
  drawer: false
});

function setTransformOrigin(node, value) {
  var _ref = node,
      style = _ref.style;
  style.transformOrigin = value;
}

var mousePosition = null;

var getClickPosition = function getClickPosition(e) {
  mousePosition = {
    x: e.clientX,
    y: e.clientY
  };
  setTimeout(function () {
    mousePosition = null;
  }, 100);
};

document.addEventListener('click', getClickPosition, true);

var Panel =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Panel, _PureComponent);

  var _super = _createSuper2(Panel);

  function Panel(props) {
    var _this;

    _classCallCheck(this, Panel);

    _this = _super.call(this, props);
    _this.panel = void 0;
    _this.handleMaskDown = void 0;
    _this.handleMaskUp = void 0;
    _this.maskDownTarget = void 0;
    _this.maskUpTarget = void 0;

    _this.savePanel = function (node) {
      _this.panel = node;
    };

    _this.handleClose = _this.handleClose.bind(_assertThisInitialized(_this));
    _this.handleMaskDown = _this.handleMaskClick.bind(_assertThisInitialized(_this), 'maskDownTarget');
    _this.handleMaskUp = _this.handleMaskClick.bind(_assertThisInitialized(_this), 'maskUpTarget');
    return _this;
  }

  _createClass(Panel, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var container = this.props.container;
      this.updateOrigin();
      this.animate();
      var _this$props = this.props,
          autoFocusButton = _this$props.autoFocusButton,
          id = _this$props.id;
      if (!autoFocusButton) return;
      var el = container.querySelector("#".concat(id, "-").concat(autoFocusButton));
      if (!el) return;
      el.focus();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (this.getShow()) return;
      this.updateOrigin();
      this.animate();
    }
  }, {
    key: "getShow",
    value: function getShow() {
      var container = this.props.container;
      if (container.classList.contains(modalClass('show'))) return true;
      return false;
    }
  }, {
    key: "getStyle",
    value: function getStyle() {
      var _this$props2 = this.props,
          width = _this$props2.width,
          height = _this$props2.height,
          top = _this$props2.top,
          position = _this$props2.position,
          style = _this$props2.style,
          fullScreen = _this$props2.fullScreen,
          drawer = _this$props2.drawer;
      var w = fullScreen ? '100vw' : width;
      var h = fullScreen ? '100vh' : height;
      return Object.assign({
        position: 'absolute'
      }, position ? {
        width: drawer && ['left', 'right'].includes(position) ? w : undefined,
        height: drawer && ['top', 'bottom'].includes(position) ? h : undefined
      } : {
        display: 'inline-flex',
        width: w,
        height: h,
        top: fullScreen ? 0 : top,
        position: 'relative'
      }, style || {});
    }
  }, {
    key: "animate",
    value: function animate() {
      var _this$props3 = this.props,
          container = _this$props3.container,
          position = _this$props3.position;
      setTimeout(function () {
        container.classList.add(modalClass('show'));
        if (!position) container.classList.add(modalClass('start'));
      });
    }
  }, {
    key: "updateOrigin",
    value: function updateOrigin() {
      var _this$props4 = this.props,
          position = _this$props4.position,
          zoom = _this$props4.zoom;
      if (position || !zoom) return;
      var node = this.panel;
      setTransformOrigin(node, '');

      if (node) {
        if (mousePosition) {
          var _node$getBoundingClie = node.getBoundingClientRect(),
              left = _node$getBoundingClie.left,
              top = _node$getBoundingClie.top;

          var ol = mousePosition.x - left;
          var ot = mousePosition.y - top;
          setTransformOrigin(node, "".concat(ol, "px ").concat(ot, "px"));
        } else {
          setTransformOrigin(node, '');
        }
      }
    } // eslint-disable-next-line
    // lockWheel(event) {
    //   event.preventDefault()
    // }

  }, {
    key: "handleMaskClick",
    value: function handleMaskClick(type, e) {
      this[type] = e.target;
    }
  }, {
    key: "handleClose",
    value: function handleClose(e) {
      e.stopPropagation();
      var _this$props5 = this.props,
          maskCloseAble = _this$props5.maskCloseAble,
          onClose = _this$props5.onClose;
      var target = e.target;
      if (!maskCloseAble) return;
      if (this.maskDownTarget !== this.maskUpTarget) return;
      if (target.matches(".".concat(modalClass('mask'))) && onClose) onClose();
    }
  }, {
    key: "renderIcon",
    value: function renderIcon() {
      var type = this.props.type;
      if (type === 'default') return null;
      var iconType = type.charAt(0).toUpperCase() + type.slice(1);
      return Icons[iconType];
    }
  }, {
    key: "renderTitle",
    value: function renderTitle() {
      var justRenderClassComponent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var _this$props6 = this.props,
          from = _this$props6.from,
          title = _this$props6.title;
      if (!title) return null; // method component

      if (from === 'method') {
        // if just render class Component, return null
        if (justRenderClassComponent) return null; // for  method function

        return (
          /*#__PURE__*/
          React.createElement("div", {
            className: modalClass('title', 'method-title')
          }, title)
        );
      } // base Component


      var icon = this.renderIcon();
      return (
        /*#__PURE__*/
        React.createElement(Card.Header, {
          className: modalClass('title', icon && 'with-icon')
        }, icon &&
        /*#__PURE__*/
        React.createElement("div", {
          className: modalClass('icon')
        }, icon), title)
      );
    }
  }, {
    key: "renderContent",
    value: function renderContent() {
      var _this$props7 = this.props,
          children = _this$props7.children,
          noPadding = _this$props7.noPadding,
          padding = _this$props7.padding,
          position = _this$props7.position,
          bodyStyle = _this$props7.bodyStyle,
          _this$props7$from = _this$props7.from,
          from = _this$props7$from === void 0 ? null : _this$props7$from;
      var style = {
        padding: noPadding === true ? 0 : padding
      };
      if (position) style.overflow = 'auto';
      if (bodyStyle) style = Object.assign(style, bodyStyle);
      if (!from || from !== 'method') return (
        /*#__PURE__*/
        React.createElement(Card.Body, {
          style: style
        }, children)
      );
      var icon = this.renderIcon();
      return (
        /*#__PURE__*/
        React.createElement(Card.Body, {
          className: modalClass('body'),
          style: style
        }, icon &&
        /*#__PURE__*/
        React.createElement("div", {
          className: modalClass('icon')
        }, icon), this.renderTitle(),
        /*#__PURE__*/
        React.createElement("div", null, children))
      );
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props8 = this.props,
          footer = _this$props8.footer,
          type = _this$props8.type,
          onClose = _this$props8.onClose,
          maskCloseAble = _this$props8.maskCloseAble,
          position = _this$props8.position,
          moveable = _this$props8.moveable,
          zoom = _this$props8.zoom,
          resizable = _this$props8.resizable,
          hideClose = _this$props8.hideClose,
          from = _this$props8.from,
          top = _this$props8.top,
          events = _this$props8.events,
          fullScreen = _this$props8.fullScreen;
      var className = classnames(modalClass('panel', type, position, zoom && !moveable && 'zoom'), this.props.className);
      var showClose = typeof hideClose === 'boolean' ? !hideClose : maskCloseAble || maskCloseAble === null;
      var maskStyle = {
        paddingBottom: fullScreen ? 0 : top
      };
      return (
        /*#__PURE__*/
        React.createElement(ZProvider, {
          value: true
        },
        /*#__PURE__*/
        React.createElement(Provider, {
          value: {
            element: undefined
          }
        },
        /*#__PURE__*/
        React.createElement("div", Object.assign({}, events, {
          style: maskStyle,
          className: modalClass('mask'),
          onMouseDown: this.handleMaskDown,
          onMouseUp: this.handleMaskUp,
          onClick: this.handleClose
        }),
        /*#__PURE__*/
        React.createElement(Card, {
          forwardedRef: this.savePanel,
          moveable: moveable,
          resizable: resizable,
          shadow: true,
          className: className,
          style: this.getStyle()
        }, showClose &&
        /*#__PURE__*/
        React.createElement("a", {
          className: modalClass('close'),
          onClick: onClose
        }, Icons.Close), this.renderTitle(true), this.renderContent(), footer &&
        /*#__PURE__*/
        React.createElement(Card.Footer, {
          className: modalClass('footer', from),
          align: "right"
        }, footer)))))
      );
    }
  }]);

  return Panel;
}(PureComponent);

Panel.defaultProps = DefaultValue;
Panel.displayName = void 0;
export { Panel as default };
Panel.displayName = 'ShineoutModalPanel';